import type { ComponentProps } from 'react';
import { OwcTableHeaderCell } from '@one/react';

export type PocTableHeaderCellProps = ComponentProps<typeof OwcTableHeaderCell>;

export const PocTableHeaderCell: React.FC<PocTableHeaderCellProps> = (props) => <OwcTableHeaderCell {...props} />;
